export const TEST_ID = 'equipmentDetails';
